/*
 * Product cards: the hover image has no src in the HTML (see impulse-showcase-card.liquid).
 * It is loaded the first time the pointer enters the card, so touch screens and fast scrolling
 * never download it. Delegated on the document so cards added by "load more" work too.
 */
(() => {
  if (window.__cardHoverImage) return;
  window.__cardHoverImage = true;
  // Hover images are only shown with a mouse on desktop widths; touch devices never need them.
  const canHover = window.matchMedia('(hover: hover) and (min-width: 990px)');

  document.addEventListener(
    'pointerover',
    (event) => {
      if (!canHover.matches || event.pointerType !== 'mouse') return;
      const card = event.target.closest?.('.impulse-showcase-card');
      if (!card) return;
      card.querySelectorAll('img[data-hover-src]').forEach((img) => {
        img.srcset = img.dataset.hoverSrcset;
        img.src = img.dataset.hoverSrc;
        img.removeAttribute('data-hover-src');
        img.removeAttribute('data-hover-srcset');
      });
    },
    { passive: true }
  );
})();
